import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';

export const AvatarMenu = ({ userPhoto, displayName, signOutUser }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleMenu}>
                <Avatar 
                    alt={`${displayName}'s Photo`} 
                    src={userPhoto} 
                    referrerPolicy="no-referrer" 
                />
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={open}
                onClose={handleClose}
            >
                <MenuItem disabled>{displayName}</MenuItem>
                <Divider />
                <MenuItem onClick={() => {
                    handleClose();
                    signOutUser();
                }}>Log Out</MenuItem>
            </Menu>
        </>
    );
}
